export enum CookiePurpose {
  StrictlyNecessary = 'strictly-necessary',
  Functional = 'functional',
  Marketing = 'marketing',
  Performance = 'performance',
}

export type CookieDomain =
  | 'localhost'
  | 'rover.local'
  | 'ciaf.local'
  | '.roverstaging.com'
  | '.catinaflat.dev'
  | '.rover.com'
  | '.app.github.dev'
  | '.catinaflat.co.uk'
  | '.catinaflat.com'
  | '.catinaflat.de'
  | '.catinaflat.at'
  | '.catinaflat.be'
  | '.catinaflat.fr'
  | '.catinaflat.ie'
  | '.catinaflat.nl'
  | '.catinaflat.ch'
  | '.catinaflat.es'
  | '.catinaflat.ca';

export type GtmCookie = {
  purpose: CookiePurpose;
  key: string;
  value: string;
  domain: CookieDomain;
  max_age: number;
  path: string;
};
